// @flow
import * as React from 'react';
import { Grid, Col } from 'react-bootstrap';
import image1 from '../images/image1.png';
import image2 from '../images/image2.png';
import image3 from '../images/image3.png';
import GlobalMenu from './menuItems/GlobalMenu';
import CustomerMenu from './menuItems/CustomerMenu';
import LocationMenu from './menuItems/LocationMenu';
import { CSSTransitionGroup } from 'react-transition-group';
import type { Organisation, Authentication } from '../types';

type Props = {
  subAccounts: Object[],
  organisations: Organisation[],
  currentOrganisation: Organisation,
  currentLocation: Object,
  authentication: Authentication,
  router: any,
  updateCurrentOrganisation: (oid: number, s?: boolean) => Promise<void>,
  getOrganisations: Function,
  updateCurrentLocation: Function
};

type State = {
  showSubAccounts: boolean,
  showCustomers: boolean
};

class MainMenu extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showSubAccounts: false,
      showCustomers: false
    };
  }

  parentOrganisations = (organisations: Organisation[]): Organisation[] => {
    return organisations.filter(o => !o.parentId);
  };

  componentDidMount() {
    this.props.getOrganisations();
    const showSubAccounts =
      this.props.subAccounts && this.props.subAccounts.length > 0;
    const showCustomers =
      this.parentOrganisations(this.props.organisations).length > 0;
    this.setState({ showSubAccounts, showCustomers });
  }

  componentWillReceiveProps(nextProps: Props) {
    const oldSubAccounts = JSON.stringify(this.props.subAccounts);
    const newSubAccounts = JSON.stringify(nextProps.subAccounts);
    if (oldSubAccounts !== newSubAccounts) {
      const showSubAccounts =
        nextProps.subAccounts && nextProps.subAccounts.length > 0;
      this.setState({ showSubAccounts });
    }
    if (this.props.organisations !== nextProps.organisations) {
      const showCustomers =
        this.parentOrganisations(nextProps.organisations).length > 0;
      this.setState({ showCustomers });
    }
  }

  render() {
    const {
      organisations,
      currentOrganisation,
      updateCurrentOrganisation,
      getOrganisations,
      subAccounts,
      currentLocation,
      updateCurrentLocation,
      authentication,
      router
    } = this.props;

    const parentOrganisations = this.parentOrganisations(organisations);

    const isInternalAdminUser = authentication.user.isInternalAdminUser;

    return (
      <Grid className="main-menu">
        <div className="text-center">
          {isInternalAdminUser && (
            <Col className="module-wrapper">
              <GlobalMenu image={image1} />
            </Col>
          )}

          {this.state.showCustomers && (
            <div className="module-wrapper">
              <CustomerMenu
                organisations={parentOrganisations}
                currentOrganisation={currentOrganisation}
                updateCurrentOrganisation={updateCurrentOrganisation}
                getOrganisations={getOrganisations}
                image={image2}
                permissions={currentOrganisation.permissions}
                router={router}
              />
            </div>
          )}

          <CSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={300}
          >
            {this.state.showSubAccounts && (
              <div className="module-wrapper">
                <LocationMenu
                  key={1}
                  locations={subAccounts}
                  currentLocation={currentLocation}
                  updateCurrentLocation={updateCurrentLocation}
                  currentOrganisation={currentOrganisation}
                  image={image3}
                  permissions={currentLocation.permissions}
                  router={router}
                />
              </div>
            )}
          </CSSTransitionGroup>
        </div>
      </Grid>
    );
  }
}

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/MainMenu.js